import { footerLinks, siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div>
            <a href="#hero" className="inline-block font-heading text-2xl text-foreground-900 mb-3">耽耽漫画</a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              耽耽漫画是国内领先的耽美漫画在线阅读平台，提供耽耽漫画在线看与下拉式免费阅读服务，海量耽耽漫画全集资源，无需下载即可快速追漫。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-foreground-600 text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                <i className="ri-qq-line text-foreground-600 text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer">
                <i className="ri-mail-line text-foreground-600 text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">快速链接</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors py-1 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500">暂无合作伙伴信息</p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">© 2026 {siteInfo.name}. All rights reserved. 本站所有内容仅供交流学习，请支持正版漫画。</p>
          <p className="text-xs text-foreground-400">下拉式阅读 · 沉浸追漫 · 免费畅读</p>
        </div>
      </div>
    </footer>
  );
}